<template>
  <div style="overflow: visible">
    <!--简略页-->
    <div v-show="!showDtl">
      <div style="text-align: left;min-width: 1630px;">
        <!--分类展示-->
        <div class="cardContainer" style="height: 600px;display: inline-block;vertical-align: top;">
          <!--只用标签页的标签头-->
          <el-tabs class="tabsTitle" v-model="activeClass" @tab-click="clickTab">
            <el-tab-pane
              v-for="(item, dindex) in sortList"
              :key="'sortList'+dindex"
              :label="item.label"
              :name="item.name.toString()"
            ></el-tab-pane>
          </el-tabs>

<!--          分类后的应用软件列表-->
          <div class="sortAppPage" v-loading="showLoading1">
            <div class="tableContainer" v-if="activeClass === '1'">
              <div class="topBar" style="padding-left:1200px">
                <div class="btnForPub btnMr" @click="openAddtypeDialog">添加</div>
                <div class="btnForPub btnMr" @click="delApp(scope.row)">删除</div>
              </div>

              <el-table :data="tableData"
                        @selection-change="handleSelectionChange"
                        style="width: 1600px;margin: auto;"
                        :header-cell-style="{background:'#d3d9e1',color:'#4C545D',fontSize:'18px'}"
                        :cell-style="{fontSize:'14px',color:'#333333'}"
                        stripe
                        border
              >
                <div slot="empty" style="font-size: 18px;text-align: center;color: #333333">
                  暂无数据
                </div>
                <el-table-column align="center" type="selection"></el-table-column>
                <el-table-column align="center" label="序号" width="100">
                  <template slot-scope="scope">
                    <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="产品类型" prop="applyName" width="300"></el-table-column>
                <el-table-column align="center" label="创建时间" prop="updateTime" width="500"></el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                    <div class="opeBtn" style="width: 56px;" @click="changeOnePublishStatus(scope.row)">
                      {{ scope.row.applyStatus === 2 ? '取消发布' : '发布' }}
                    </div>
                    <!--              <div class="opeBtn" @click="openPreviewDialog(scope.row)">查看详情</div>-->
                    <div class="opeBtn" :style="{cursor: scope.row.applyStatus === 2 ? 'not-allowed' : 'pointer'}" @click="openEditDialog(scope.row)">编辑</div>
                    <div class="opeBtn" @click="delApp(scope.row)">删除</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="tableContainer" v-else>
              <div class="topBar">
                <div class="title">产品类型</div>
                <el-select
                  v-model="appType"
                  clearable
                  @change="getAllAppList"
                >
                  <el-option
                    v-for="item in appTypeList"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-input
                  v-model="keyWords"
                  class="search"
                  placeholder="请输入"
                  clearable
                  @clear="getAllAppList"
                  @keyup.enter.native="getAllAppList"
                >
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="getAllAppList"></i>
                </el-input>
                <div class="btnForPub btnMr2" @click="openAddtypeDialog">添加</div>
                <div class="btnForPub btnMr" @click="delApp(scope.row)">删除</div>
              </div>
              <el-table :data="tableData"
                        @selection-change="handleSelectionChange"
                        style="width: 1600px;margin: auto;"
                        :header-cell-style="{background:'#d3d9e1',color:'#4C545D',fontSize:'18px'}"
                        :cell-style="{fontSize:'14px',color:'#333333'}"
                        stripe
                        border
              >
                <div slot="empty" style="font-size: 18px;text-align: center;color: #333333">
                  暂无数据
                </div>
                <el-table-column align="center" type="selection"></el-table-column>
                <el-table-column align="center" label="序号" width="70">
                  <template slot-scope="scope">
                    <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="产品类型" prop="applyName" width="200"></el-table-column>
                <el-table-column align="center" label="产品型号" prop="applytypeName" width="200"></el-table-column>
                <el-table-column align="center" label="创建时间" prop="updateTime" width="400"></el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                    <div class="opeBtn" style="width: 56px;" @click="changeOnePublishStatus(scope.row)">
                      {{ scope.row.applyStatus === 2 ? '取消发布' : '发布' }}
                    </div>
                    <!--              <div class="opeBtn" @click="openPreviewDialog(scope.row)">查看详情</div>-->
                    <div class="opeBtn" :style="{cursor: scope.row.applyStatus === 2 ? 'not-allowed' : 'pointer'}" @click="openEditDialog(scope.row)">编辑</div>
                    <div class="opeBtn" @click="delApp(scope.row)">删除</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-if="sortAppList.length > 0">
            <el-pagination
              style="text-align: center; margin-top: 20px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[6,12,18,36,72]"
              :page-size="pageSize"
              layout="total,sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
<!--    添加类型弹窗-->
    <el-dialog
      :visible.sync="addOrEditVisible"
      append-to-body
      class="loginDialog"
      width="550px"
      @closed="closeAddOrEditDialog"
      :close-on-click-modal="false"
    >
      <div class="loginDialog__wrap" style="margin-top: -30px;">
        <div class="loginDialog__wrap__title">
          添加产品类型
          <i class="el-icon-close" @click="addOrEditVisible = false"></i>
        </div>
        <div class="loginDialog__wrap__content">
          <el-form
            ref="appForm"
            style="text-align: left;"
            label-position="right"
            label-width="120px"
            :model="appDtl"
            :rules="rules"
          >
            <el-form-item
              label="产品类型"
              prop="applyName"
              :rules="[
            { required: true, message: '不能为空', trigger: 'change' },
          ]"
            >
              <el-input
                style="width: 300px;"
                v-model="appDtl.applyName"
                :maxlength="$len.input"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <div style="text-align: right;">
              <div class="btnForPub btnMr" style="width: 100px;" @click="closeAddOrEditDialog">取消</div>
              <div class="btnForPub btnMr" style="width: 100px;" @click="confirmForm(0)">确定</div>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <!--    编辑类型弹窗-->
    <el-dialog
      :visible.sync="addOrEditVisible"
      append-to-body
      class="loginDialog"
      width="550px"
      @closed="closeAddOrEditDialog"
      :close-on-click-modal="false"
    >
      <div class="loginDialog__wrap" style="margin-top: -30px;">
        <div class="loginDialog__wrap__title">
          编辑产品类型
          <i class="el-icon-close" @click="addOrEditVisible = false"></i>
        </div>
        <div class="loginDialog__wrap__content">
          <el-form
            ref="appForm"
            style="text-align: left;"
            label-position="right"
            label-width="120px"
            :model="appDtl"
            :rules="rules"
          >
            <el-form-item
              label="产品类型"
              prop="applyName"
              :rules="[
            { required: true, message: '不能为空', trigger: 'change' },
          ]"
            >
              <el-input
                style="width: 300px;"
                v-model="appDtl.applyName"
                :maxlength="$len.input"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <div style="text-align: right;">
              <div class="btnForPub btnMr" style="width: 100px;" @click="closeAddOrEditDialog">取消</div>
              <div class="btnForPub btnMr" style="width: 100px;" @click="confirmForm(0)">确定</div>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <!--    删除类型弹窗-->
    <el-dialog
      :visible.sync="deleteVisible"
      append-to-body
      class="loginDialog"
      width="550px"
      @closed="closeAddOrEditDialog"
      :close-on-click-modal="false"
    >
      <div class="loginDialog__wrap" style="margin-top: -30px;">
        <div class="loginDialog__wrap__title">
          删除产品类型
          <i class="el-icon-close" @click="deleteVisible = false"></i>
        </div>
        <div class="loginDialog__wrap__content">
          <div>
            <div>请确认是否删除</div>
            <div style="text-align: right;margin-right: 20px">
              <div class="btnForPub btnMr" style="width: 80px;" @click="closeAddOrEditDialog">取消</div>
              <div class="btnForPub btnMr" style="width: 80px;" @click="confirmForm(0)">确定</div>
            </div>
          </div>

        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  // getRecommendApp,
  sortAppPageData
} from '../../../api/appStore/appHome'
import {batchCancelPublish, batchPublish, deleteApp} from '../../../api/appStore/appPublish'
import { getAllGMOSApp } from '../../../api/appStore/allApp'
// import appDetails from "./appDetails";
// import { selectApplystypeList } from "../../../api/appStore/appCommon";
// import {addorEditApp} from "../../../api/appStore/appPublish";
// import AppPublish from "../../../views/market/appPublish";

export default {
  name: 'product',
  components: {
    // AppPublish
  },
  data () {
    return {
      // 展示详情页标识符
      addOrEditVisible: false, // 添加or编辑的弹窗
      deleteVisible: false, // 删除弹窗
      showDtl: false,
      // 单个app的详细数据
      appInfo: null,
      // GMOS APP推荐列表
      goodAppList: [
        // { applyName: '高效控制', imsUrl: require('@/assets/market/u362.png') },
      ],
      // 分类展示标签页选中
      activeClass: '1',

      // 分类GMOS APP列表
      sortAppList: [
        // { applyName: '高效控制', imsUrl: require('@/assets/market/u362.png') },
      ],
      keyWords: '',
      // 分类
      sortList: [
      ],

      tableData: [],

      appDtl: {
        id: '',
        // GMOS APP封面
        appImg: {
          imageUrl: '',
          imageUrlArr: [
            // {'url':'http://172.16.200.156:8088/apis/api/cafca97472454cd7b7651362832557b5.png'}
          ], // 图片上传组件的绑定值需为list
          imageId: ''
        },
        applyName: '', // GMOS APP名称
        price: '', // 价格
        appType: '', // GMOS APP类型
        appId: '', // GMOS APP，上传文件后返回appId
        appArr: [], // GMOS APP文件上传列表
        version: '', // GMOS APP版本
        premise: [], // 运行环境
        dvcType: [], // 支持设备类型
        dvcMaster: '', // 支持设备厂家
        dvcAgreement: [], // 支持设备协议
        desc: '' // 功能描述
      },
      // 排行榜列表
      rankList: [],

      // 定时刷新器
      timer: null,
      // 分页器相关
      currentPage: 1,
      pageSize: 18,
      total: 0,

      // 刷新动画效果
      showLoading1: false,
      appTypeList: [
        // { label: '设备监控', value: '1' },
      ]
    }
  },
  methods: {
    // ----------操作类----------
    // 跳转到分类详情页
    // gotoSortDtl() {
    //   this.$router.push('sortApp/' + this.activeClass);
    // },
    // 进入详情页
    gotoAppDetails (item) {
      this.appInfo = item
      this.showDtl = true
    },
    // 返回首页
    returnToAppHome () {
      this.appInfo = null
      this.showDtl = false
    },
    // 切换分页
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSortAppList()
    },
    // 切换单页大小
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getSortAppList()
    },
    // 切换分类
    clickTab (tab) {
      // 刷新分类列表
      // this.getSortAppList();
      console.log(this.activeClass)
    },
    // 添加类型
    openAddtypeDialog () {
      if (this.$refs.appForm) {
        this.$refs.appForm.clearValidate()
      }
      this.dialogTitle = '上传固件'
      this.appDtl.id = ''
      this.addOrEditVisible = true
    },
    delApp (rowData) {
      this.deleteVisible = true
      this.$del({ title: '', msg: '请确认是否删除该GMOS APP' }).then(() => {
        // 删除末页唯一一条数据时，当前页要往前跳一页，否则搜不出数据
        if (this.currentPage > 1) {
          let maxPage = Math.ceil(this.total / this.pageSize)
          if (this.currentPage === maxPage && this.tableData.length === 1) {
            this.currentPage -= 1
          }
        }
        deleteApp(rowData.id).then(res => {
          this.$msg('删除成功', 'success')
          this.searchData()
        }).catch(e => e)
      }).catch(e => e)
    },
    // 单个GMOS APP的发布/取消发布
    changeOnePublishStatus(rowData) {
      if (rowData.applyStatus === 0) {  // 未发布状态下
        batchPublish(rowData.id.toString()).then(res => {
          this.$msg('发布成功', 'success');
          this.searchData();
        }).catch(e => e);
      } else if (rowData.applyStatus === 2) { // 已发布状态下
        batchCancelPublish(rowData.id.toString()).then(res => {
          this.$msg('取消发布成功', 'success');
          this.searchData();
        }).catch(e => e);
      }
    },
    // 关闭新增或编辑弹窗
    closeAddOrEditDialog () {
      if (this.$refs.appForm) {
        this.$refs.appForm.resetFields()
        // this.resetAppDtl();
      }
      this.appDtl.appImg.imageUrlArr = [] // 清空图片列表
      this.appDtl.appArr = [] // 清空上传文件的列表
      this.addOrEditVisible = false
    },
    // 弹窗的提交事件
    confirmForm (applyStatus) { // 0是保存，2是发布
      this.$refs.appForm.validate((valid) => {
        if (valid) {
          if (!this.appDtl.id) { // 添加的情况
            addorEditApp({
              createBy: this.getUserName,
              imsId: this.appDtl.appImg.imageId, // GMOS APP封面
              applyName: this.appDtl.applyName, // GMOS APP名称
              price: this.appDtl.price, // 价格
              applytypeId: this.appDtl.appType, // GMOS APP类型
              appId: this.appDtl.appId, // GMOS APP导入
              version: this.appDtl.version, // GMOS APP版本
              operatingCarrier: this.appDtl.premise.toString(), // 运行环境
              deviceTypes: this.appDtl.dvcType.toString(), // 支持设备类型
              deviceManufacturers: this.appDtl.dvcMaster, // 支持设备厂家
              deviceProtocols: this.appDtl.dvcAgreement.toString(), // 支持设备协议
              applyDescription: this.appDtl.desc, // 功能描述
              applyStatus: applyStatus // GMOS APP状态
            }).then(res => {
              if (res.returnCode === '100') {
                this.$msg('新增成功', 'success')
                this.closeAddOrEditDialog()
                this.searchData()
              } else {
                this.$msg(res.returnMsg)
              }
            }).catch(e => e)
          } else if (this.appDtl.id) { // 编辑的情况
            addorEditApp({
              createBy: this.getUserName,
              id: this.appDtl.id, // GMOS APPid，编辑才会带出
              imsId: this.appDtl.appImg.imageId, // GMOS APP封面
              applyName: this.appDtl.applyName, // GMOS APP名称
              price: this.appDtl.price, // 价格
              applytypeId: this.appDtl.appType, // GMOS APP类型
              appId: this.appDtl.appId, // GMOS APP导入
              version: this.appDtl.version, // GMOS APP版本
              operatingCarrier: this.appDtl.premise.toString(), // 运行环境
              deviceTypes: this.appDtl.dvcType.toString(), // 支持设备类型
              deviceManufacturers: this.appDtl.dvcMaster, // 支持设备厂家
              deviceProtocols: this.appDtl.dvcAgreement.toString(), // 支持设备协议
              applyDescription: this.appDtl.desc, // 功能描述
              applyStatus: applyStatus, // GMOS APP状态
              applyNameChange: this.checkKeyChange() // 判断是否重名的参数
            }).then(res => {
              if (res.returnCode === '100') {
                this.$msg('编辑成功', 'success')
                this.closeAddOrEditDialog()
                this.searchData()
              } else {
                this.$msg(res.returnMsg)
              }
            }).catch(e => e)
          }
        }
      })
    },
    async getSortAppList () {
      this.showLoading1 = true
      await sortAppPageData(
        parseInt(this.activeClass),
        this.currentPage,
        this.pageSize
      ).then(res => {
        // this.sortAppList = res.returnData.applys.slice(0,18); // 最多支持18个GMOS APP展示
        this.sortAppList = res.returnData.applys
        this.total = res.returnData.count ? res.returnData.count : 0
      }).catch(e => e)
      this.showLoading1 = false
    },
    async getAllAppList () {
      this.showLoading1 = true
      await getAllGMOSApp({
        applyName: this.keyWords,
        applytypeId: this.appType,
        deviceTypeId: this.dvcType,
        curPage: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        if (res.returnCode === '1000') { // 该接口还需给GMOS用，因此特殊采用1000的returnCode
          this.appList = res.returnData.applys
          this.total = res.returnData.count ? res.returnData.count : 0
        } else {
          this.$msg(res.returnMsg)
        }
      }).catch(e => e)
      this.showLoading1 = false
    },
    // 获取全部分类
    getTabsList () {
      // this.sortList = [
      //   // {lable:"产品类型", name:"1"},
      //   // {lable:"产品类型", name:"1"},
      // ];
      let resArr = []
      let item = {
        label: '产品类型',
        name: '1'
      }
      resArr.push(item)
      let item2 = {
        label: '产品型号',
        name: '2'
      }
      resArr.push(item2)
      this.sortList = resArr

      // selectApplystypeList().then(res => {
      //   if (res.returnCode === '100') {
      //     let dataArr = res.returnData;
      //     let resArr = [];
      //     for (let i = 0; i < dataArr.length; i++) {
      //       let item = {
      //         label: dataArr[i].applytypeName,
      //         name: dataArr[i].applytypeId
      //       };
      //       resArr.push(item);
      //     };
      //     this.sortList = resArr;
      //   }
      // }).catch(e => e);
    },
    // 接口请求，初始化页面数据
    initPageData () {
      this.getSortAppList()
      this.getTabsList()
    }
  },
  mounted () {
    this.initPageData()

    this.timer = setInterval(() => {
      this.initPageData()
    }, 1000 * 60)
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style scoped lang="less">
  /*框架样式*/
  .cardContainer {
    color: #333333;
    border: 1px solid #f0f0f0;
    border-radius: 5px;
    box-sizing: border-box;
    background-color: white;
    margin-bottom: 10px;
    .cardTitle {
      text-align: left;
      font-size: 18px;
      font-weight: bold;
      height: 40px;
      line-height: 40px;
      padding-left: 15px;
      border-bottom: 2px solid #f0f0f0;
      cursor: default;
    }
    .cardContent {
      margin-top: 15px;
      text-align: left;
      max-width: 1600px;
      margin-left: auto;
      margin-right: auto;
      white-space: nowrap;
    }
  }
  /*按钮样式*/
  .btnForPub {
    background-color: #5c89e5;
    color: #FFFFFF;
    font-size: 16px;
    height: 40px;
    width: 120px;
    line-height: 40px;
    display: inline-block;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
  }
  .btnMr {
    margin-right: 30px;
    margin-left: 30px;
  }
  .btnMr2 {
    margin-right: 30px;
    margin-left: 690px;
  }

  .loginDialog__wrap {
    box-shadow: 3px 3px 7px 0 rgba(0, 0, 0, 0.2);
    border-right: 4px;
    background-color: transparent;

    &__title {
      position: relative;
      text-align: left;
      font-size: 20px;
      background-color: #5c89e5;
      color: #ffffff;
      font-weight: bold;
      padding: 12px 36px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;

      .el-icon-close {
        position: absolute;
        right: 8px;
        top: 0;
        bottom: 0;
        margin: auto;
        cursor: pointer;
        font-size: 28px;
        height: 28px;
      }
    }

    &__content {
      padding: 37px 36px 10px 20px;
      background-color: #fff;

      .smallbtn {
        font-size: 13px;
        color: #5c89e5;
        padding-top: 2px;
        display: inline-block;
        cursor: pointer;

        &.line {
          border-bottom: 2px solid;
          /*padding-bottom: 2px;*/
        }
      }

      .login-btn-container {
        text-align: center;
        margin: 12px auto;
      }

      .login-btn {
        display: inline-block;
        background-color: #5c89e5;
        border-radius: 6px;
        padding: 6px 24px;
        color: #ffffff;
        font-size: 17px;
        cursor: pointer;
      }
    }
  }
  .topBar {
    margin-bottom: 20px;
    text-align: left;
    .search {
      width: 200px;
      margin-left: 20px;
      i {
        cursor: pointer;
      }
    }

    .title {
      display: inline-block;
      font-size: 18px;
      margin: 0 10px 0 20px;
    }
  }
  /*GMOS APP样式*/
  .cardApp {
    cursor: pointer;
    display: inline-block;
    text-align: center;
    margin: 0 20px;
    .appImg {
      width: 120px;
      height: 120px;
      /*border: 1px solid #008FE0;*/
      border: 1px solid #617799;
      border-radius: 5px;
      box-sizing: border-box;
      line-height: 116px; // 图裂放中间位置
      .imgCenter {
        display: inline-block;
        vertical-align: middle;
      }
    }
    .appTitle {
      font-size: 16px;
      margin-top: 5px;
      width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  /*分页分类GMOS APP样式*/
  /deep/ .tabsTitle .el-tabs__item{
    font-size: 18px;
    font-weight: bold;
    padding: 0 20px;
  }

  /deep/ .tabsTitle .el-tabs__nav-wrap {
    padding-left: 15px;
  }
  .sortAppPage {
    max-height: 486px;
    padding-left: 19px;
    padding-right: 19px;
    /*overflow-y: auto;*/
  }

  /*排行榜样式*/
  .rank {
    display: flex;
    font-size: 16px;
    line-height: 32px;
    margin-top: 22px;
    .HotColor {
      /*排行前三的序号变色*/
      background-color: #314659 !important;
      color: #FFFFFF;
    }
    .NoContainer {
      width: 70px;
      text-align: center;
      display: inline-block;
      .No {
        display: inline-block;
        background-color: #f0f2f5;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 20px;
      }
    }
    .name {
      display: inline-block;
      width: 120px;
      white-space: pre;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .barContainer {
      display: inline-block;
      flex: 4;
      padding: 0 2px;
      .bar {
        background-color: #FF9933;
        width: 100%;
        height: 25px;
        border-radius: 20px;
      }
    }
    .sumContainer {
      display: inline-block;
      flex: 1;
      text-align: right;
      padding-right: 30px;
      .sum {
        white-space: nowrap;
      }
      .sum:after {
        content: "次";
      }
    }
  }

  .noData {
    font-size: 20px;
    text-align: center;
  }

  .sortPageBtn {
    text-align: center;
  }
</style>
